import { ProductComponent } from './ProductComponent';

export function ProductTemplate({ product, renderSections }) {
  return <ProductComponent product={product} sections={renderSections()} />;
}

ProductTemplate.displayName = 'ProductTemplate';
